import { Component, forwardRef, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { ControlService } from '../services/control.service';

@Component({
  selector: 'partnerhub-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
  ],
})
export class FileUploadComponent implements OnInit, ControlValueAccessor, OnDestroy {
  public get _required(): boolean {
    if (this.required === '' || this.required) {
      return true;
    }
    return false;
  }

  get invalid(): boolean {
    return (this.dirty || this.formSubmitted) && this.errors !== null;
  }

  private readonly fileReader = new FileReader();

  @Input() public accept = '';

  public dirty = false;

  public disabled = false;

  @Input() public errors: ValidationErrors = null;

  public file: File;

  public focusOutStream$ = new Subject();

  public formSubmitted = false;

  @Input() public label: string;

  public remoteFile = [];

  @Input() public required: boolean | string = false;

  @Input() public url = '';

  @Input() chooseLabel = null;

  constructor(@Optional() private readonly controlService: ControlService) {}

  private upload(files): void {
    this.file = files[0];

    this.dirty = true;

    this.onChange(this.file);
  }

  public ngOnDestroy(): void {
    this.focusOutStream$.next(true);

    this.focusOutStream$.complete();
  }

  public ngOnInit() {
    if (this.controlService) {
      this.controlService.formEvent$.subscribe(_ => (this.formSubmitted = true));
    }
  }

  public onChange = (_: any) => {};

  public onClickRemoveFile(element): void {
    /** Reset the input element */
    element.value = '';

    this.file = null;

    this.dirty = true;

    this.onChange(this.file);
  }

  public onFileChange(event): void {
    if (event.currentFiles.length > 0) {
      this.upload(event.currentFiles);
    }
  }

  public onFileClear(event): void {
    this.file = null;
    this.dirty = true;
    this.onChange(this.file);
  }

  public onTouch = () => {};

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(value: any): void {
    this.file = value;

    if (this.file && typeof this.file !== 'string') {
      // TODO: Fix upload service
      // this.uploadService.getFile(this.file).subscribe(file => {
      const getExtension = /\.[0-9a-z]+$/i;
      this.remoteFile = [new File([this.file], '', { type: this.file.type })];
      // });
    }

    this.onChange(this.file);
  }
}
